import * as React from 'react';
import { resolveConnectorIcon } from '../utils/connectors-utils';

export interface IConnectorLogoProps {
  connectorName: string;
  serverIconUrl: string;
}

const ConnectorLogo: React.FC<React.PropsWithChildren<IConnectorLogoProps>> = ({
  connectorName,
  serverIconUrl,
}) => {
  const LocalLogo = resolveConnectorIcon(connectorName);

  return LocalLogo ? (
    <LocalLogo height={30} style={{ maxWidth: 70, minWidth: 40 }} />
  ) : (
    <img src={serverIconUrl} alt={connectorName} style={{ height: 30 }} />
  );
};

export default ConnectorLogo;
